import React from 'react';
import classnames from 'classnames';
import ReactCommonmark from 'react-commonmark';
import URLText from '../../v2/form/URLText/URLText';
import QuoteFileRender from './QuoteFileRender/QuoteFileRender';
import AIResponseFileRender from './AIResponseFileRender/AIResponseFileRender';

interface URLReplacerProps {
  href: string;
  children: React.ReactNode;
}

const isS3Url = (url: string) => {
  return url.includes('s3.amazonaws.com');
};

const getUrlVariant = (href: string) => {
  let urlVariant = 'url';
  if (href.includes('/dj/api/v1/file')) {
    urlVariant = 'quote_file';
  } else if (isS3Url(href)) {
    urlVariant = 'ai_conversation_response_file';
  }
  return urlVariant;
};
const URLReplacer: React.FC<URLReplacerProps> = ({ href, children }) => {
  const urlVariant = getUrlVariant(href);
  switch (urlVariant) {
    case 'quote_file':
      return <QuoteFileRender href={href} children={children} />;
    case 'ai_conversation_response_file':
      return <AIResponseFileRender href={href} children={children} />;
    default:
      return (
        <a href={href} target="_blank" rel="noreferrer">
          {children}
        </a>
      );
  }
};

const removeFormatting = (text: string) => {
  const specialCharacters = [
    '#',
    '-',
    '*',
    '_',
    '>',
    '(',
    ')',
    '[',
    ']',
    '{',
    '}',
    '!',
    '`',
    '.',
    '|',
    '^',
    ':',
    '~',
  ];

  specialCharacters.forEach((character) => {
    text = text.replaceAll(`${character}`, `\\${character}`);
  });

  return text;
};

interface MarkdownRenderProps {
  source: string;
  format: boolean;
  className?: string;
  /**
   * @default false
   */
  preserveSpaces?: boolean;
}

const MarkdownRender: React.FC<MarkdownRenderProps> = ({
  source,
  format,
  className,
  preserveSpaces = false,
}) => {
  const sourceFormatted = URLText(format ? source : removeFormatting(source));
  const content = preserveSpaces
    ? sourceFormatted.replaceAll('\n', '<br/>')
    : sourceFormatted;

  return (
    <ReactCommonmark
      className={classnames(className, {
        'markdown-preserve-spaces': preserveSpaces,
      })}
      source={content}
      softBreak="br"
      renderers={{
        Link: URLReplacer,
      }}
    />
  );
};

export default MarkdownRender;
